import Identifiers from './Identifiers';

export default Identifiers;